import Notification from '../../components/Notification.tsx'

interface Props {
  flashMessages: {
    text: string
    isError: boolean
  }[]
}

const FlashMessages = ({ flashMessages }: Props) => (
  <>
    {flashMessages.map((message) => (
      <Notification key={message.text} danger={message.isError} success={!message.isError} small>
        {message.text}
      </Notification>
    ))}
  </>
)

export default FlashMessages
